import React from 'react'
import { Card } from 'primereact/card'
import { Badge } from 'primereact/badge'
import { ShippingOrder } from '../../../../DeShippingTableWrapper'

interface RejectedItemsKPIsProps {
  selectedOrders: ShippingOrder[]
  orderAnalysis: OrderAnalysis | null
}

interface OrderAnalysis {
  storeDeclinedOnly: number
  adminRejectedOnly: number
  mixedOrders: number
  totalOrders: number
}

export const RejectedItemsKPIs: React.FC<RejectedItemsKPIsProps> = ({
  selectedOrders,
  orderAnalysis
}) => {
  // Calculate summary statistics
  const totalRejectedItems = selectedOrders.reduce((sum, order) => sum + (order.declined_items || 0), 0)
  const totalOrderValue = selectedOrders.reduce((sum, order) => sum + order.order_subtotal, 0)

  return (
    <div className="mb-4">
      <h5 className="mb-3 flex align-items-center gap-2">
        <i className="pi pi-refresh" style={{ fontSize: '1.25rem', marginRight: '8px' }}></i>
        Reassignment Summary
      </h5>
      
      {/* Main KPI Cards */}
      <div 
        className="p-3 mb-4" 
        style={{ 
          display: 'flex', 
          justifyContent: 'space-around', 
          alignItems: 'center',
          width: '100%',
          gap: '16px'
        }}
      >
        <Card style={{ 
          textAlign: 'center', 
          flex: '1',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px',
          padding: '0',
          color: 'white',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
          border: 'none'
        }} className="p-0">
          <div style={{ padding: '12px 16px' }}>
            <div style={{ marginBottom: '4px' }}>
              <i className="pi pi-shopping-cart" style={{ fontSize: '1.6rem' }}></i>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2px' }}>
              {selectedOrders.length}
            </div>
            <div style={{ fontSize: '0.85rem', opacity: '0.9' }}>
              Orders to Reassign
            </div>
          </div>
        </Card>

        <Card style={{ 
          textAlign: 'center', 
          flex: '1',
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          borderRadius: '12px',
          padding: '0',
          color: 'white',
          boxShadow: '0 4px 15px rgba(240, 147, 251, 0.3)',
          border: 'none'
        }} className="p-0">
          <div style={{ padding: '12px 16px' }}>
            <div style={{ marginBottom: '4px' }}>
              <i className="pi pi-sync" style={{ fontSize: '1.6rem' }}></i>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2px' }}>
              {totalRejectedItems}
            </div>
            <div style={{ fontSize: '0.9rem', opacity: '0.9' }}>
              Items to Reassign
            </div>
          </div>
        </Card>

        <Card style={{ 
          textAlign: 'center', 
          flex: '1',
          background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
          borderRadius: '12px',
          padding: '0',
          color: 'white',
          boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)',
          border: 'none'
        }} className="p-0">
          <div style={{ padding: '12px 16px' }}>
            <div style={{ marginBottom: '4px' }}>
              <i className="pi pi-dollar" style={{ fontSize: '1.6rem' }}></i>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2px' }}>
              ${totalOrderValue.toFixed(2)}
            </div>
            <div style={{ fontSize: '0.9rem', opacity: '0.9' }}>
              Total Value
            </div>
          </div>
        </Card>

      </div>
    </div>
  )
} 